import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/apiAuthInterceptor'; // attach signed auth tokens to API calls (T0-5)
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthProvider } from './authProvider';
import { injectTheme } from './config/theme-injector';

// Inject theme CSS variables before rendering
injectTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
